import { useCallback, useEffect, useRef, useState } from "react";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";

import { dateDifferenceFromNow } from "@js/utils/date";

const getNewCount = (endTime: Dayjs | string) => {
  return dateDifferenceFromNow(endTime, "seconds");
};

// Really simple hook which manages seconds only. Please consider some hook from npm if you need more features
export const useCountdown = (countDownEndTime?: string | Dayjs) => {
  const [countdown, setCountDown] = useState<number | undefined>(() =>
    countDownEndTime ? getNewCount(countDownEndTime) : undefined,
  );
  const interval = useRef<ReturnType<typeof setInterval> | null>(null);

  const startCountdown = useCallback(() => {
    const endTime = countDownEndTime
      ? countDownEndTime
      : dayjs().add(3, "seconds");
    setCountDown(getNewCount(endTime));

    interval.current = setInterval(() => {
      const newCount = getNewCount(endTime);
      setCountDown(newCount);

      if (newCount <= 0 && interval.current) {
        clearInterval(interval.current);
      }
    }, 1000);
  }, [countDownEndTime]);

  useEffect(() => {
    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, []);

  return {
    startCountdown,
    countdown,
    countdownFinished: typeof countdown !== "undefined" && countdown <= 0,
  };
};
